/* eslint-disable class-methods-use-this */
import * as marietta from '../..';
import { MonicaObject } from '.';
import { SVGSprite } from '../flash/display';
import { Point } from '../../core';
import { ITEM_MODE_NO } from '../Constants';
import * as graphicLibs from '../../graphicLibs/index';

class Fitting extends MonicaObject {
    private static readonly FITTING_ID_PREFIX: string = 'fit';

    private static readonly FITTING_ID_PREFIX_LENGTH: number = 3;

    private resizeObj: SVGSprite;

    private hashira1: SVGSprite;

    private hashira2: SVGSprite;

    private wall: SVGSprite;

    private yoroi1: SVGSprite;

    private yoroi2: SVGSprite;

    // 子要素リスト
    public childrenList: any[];

    private _snapWall:marietta.webcad.item.parts.Wall;

    get snapWall() { return this._snapWall; }

    set snapWall(value:marietta.webcad.item.parts.Wall) {
      this._snapWall = value;
    }

    private _prevSnapWall:marietta.webcad.item.parts.Wall;

    get prevSnapWall() { return this._prevSnapWall; }

    set prevSnapWall(value:marietta.webcad.item.parts.Wall) {
      this._prevSnapWall = value;
    }

    isCustomRotate: boolean = false;

    // constructor(_itemInfo: marietta.webcad.collection.ItemInfoCollection) {
    //   super(_itemInfo);
    // }

    /**
     * 縮尺の初期化処理
     */
    initMeasurement() {
      // 元サイズの保持
      const rect = this.spt.getBoundingClientRect();
      this.originalWidth = rect.width;
      this.originalHeight = rect.height;

      if ((this.itemInfo.x) !== undefined && (this.itemInfo.x) !== null) {
        // XYの位置を復元
        this.updateTransforms();

        // カレントの設定
        marietta.webcad.WebCADGlobal.itemManager.currentItem = this;
      }
    }

    get widthmm(): number {
      // mmで保存されている場合は、itemInfoのmmを使用する
      if (this.itemInfo.use_mm) {
        return this.itemInfo.widthmm;
      }

      let retValue: number = this.getMyWidthForSave();
      retValue = Math.round(marietta.webcad.util.WebCADUtil.convertPixToMM(retValue));
      return retValue;
    }

    /**
    * ビューの作成
    */
    createImage() {
      super.createImage();

      this.spt.name = '$parent';

      this.wall = this.spt.getChildByName('wall');
      this.hashira1 = this.spt.getChildByName('hashira_1');
      this.hashira2 = this.spt.getChildByName('hashira_2');
      this.resizeObj = this.spt.getChildByName('resizeObj');
      this.yoroi1 = this.spt.getChildByName('yoroi_1');
      this.yoroi2 = this.spt.getChildByName('yoroi_2');

      /*
        子要素の１つ（スケーリングするやつ）のbindParentDefineをtrueに
        する事で、スケール変更時に親要素が持つdefタグを更新するように(線幅固定の処理)
        */
      this.resizeObj.bindParentDefine = true;

      // for test
      /*
        this.wall.name = "$wall";
        this.hashira1.name = "$hashira_1";
        this.hashira2.name = "$hashira_2";
        this.resizeObj.name = "$resizeObj";
        */
    }

    /**
     * グリッドに吸い付く
     * */
    snapToGrid = () => {
      const snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
      this.itemInfo.x = Math.round(this.itemInfo.x / snapUnit) * snapUnit;
      this.itemInfo.y = Math.round(this.itemInfo.y / snapUnit) * snapUnit;
      this.updateTransforms();

      // これが原因でieでは無限ループ
      // 更新の必要性がなさそうなのでとりあえず、コメントアウト
      // TODO: 要確認
      // //カレントの更新
      // marietta.webcad.WebCADGlobal.itemManager.currentItem = this;
    }

    /**
     * サイズ変更
     * @param Number 幅
     * @param Number 高
     * @param Boolean ピクセル単位か否か
     * */
    changeSize(w: number, h: number, isPixUnit: Boolean = true) {
      let _w = w;

      // サイズ変更
      if (!isPixUnit) {
        this.itemInfo.widthmm = Math.round(Math.abs(w));
        // ピクセル単位
        _w = marietta.webcad.util.WebCADUtil.convertMMToPix(w);
        this.itemInfo.width = Math.round(_w);
      } else {
        this.itemInfo.width = Math.round(_w);
        this.itemInfo.widthmm = Math.round(marietta.webcad.util.WebCADUtil.convertPixToMM(Math.abs(_w)));
      }

      /** 切り捨てしない CADAPIへ影響を及ぼすため */
      this.itemInfo.width = marietta.webcad.util.WebCADUtil.convertMMToPix(this.itemInfo.widthmm);

      // サイズの変更
      // k.kubonaka WEBCAD-1058対応
      this.changeFittingSize(Math.abs(_w));

      // パネル更新
      marietta.webcad.WebCADGlobal.itemControlPanel.panelUpdate();
    }

    /**
     * サイズ変更
     * @w 幅
     * */
    changeFittingSize(w: number) {
      this.wall.width = w - marietta.webcad.WebCADGlobal.WALL_WIDTH;
      this.hashira2.x = w / 2;
      this.hashira1.x = -w / 2;
      this.yoroi1.x = -w / 2 - marietta.webcad.WebCADGlobal.WALL_WIDTH / 2;
      this.yoroi2.x = w / 2 - marietta.webcad.WebCADGlobal.WALL_WIDTH / 2;

      // let motoWidth: number;
      let outside: number;
      if (marietta.webcad.WebCADGlobal.isDemado(this.itemInfo.id)) {
        switch (this.itemInfo.id) {
          case 'fit20_01':
          case 'fit20_02':
          case 'fit20_03':
            // motoWidth = 160.8;
            outside = 29.0;
            break;
          case 'fit21_06':
            // motoWidth = 20;
            outside = -40;
            break;
          case 'fit21_07':
            // motoWidth = 60;
            outside = 0;
            break;
          case 'fit32_01':
            // motoWidth = 150;
            outside = -20;
            break;
          default:
            // motoWidth = 130;
            outside = 0;
        }
        this.resizeObj.width = w + marietta.webcad.WebCADGlobal.WALL_WIDTH + outside;
        this.resizeObj.y = -5;
        if (this.itemInfo.id === 'fit21_06') this.resizeObj.y = 0;
        this.resizeObj.scaleY = 1;
      } else {
        switch (this.itemInfo.id) {
          case 'fit10_01':
          case 'fit10_05':
          case 'fit10_06':
            this.resizeObj.width = (w - marietta.webcad.WebCADGlobal.WALL_WIDTH) / 2;
            break;
          case 'fit03_06':
            this.resizeObj.width = (w - marietta.webcad.WebCADGlobal.WALL_WIDTH * 2) / 2;
            break;
          case 'fit06_01':
          case 'fit06_02':
          case 'fit06_03':
          case 'fit06_04':
            this.resizeObj.width = ((w - marietta.webcad.WebCADGlobal.WALL_WIDTH) / 20) * 11.8;
            break;
          default:
            this.resizeObj.width = w - marietta.webcad.WebCADGlobal.WALL_WIDTH;
        }

        this.resizeObj.y = -5;
        this.resizeObj.scaleY = this.resizeObj.scaleX;
        if (this.itemInfo.id === 'fit15_02') this.resizeObj.y = 0;
      }

      // 壁が長い場合
      switch (this.itemInfo.id) {
        case 'fit01_03':
          this.wall.width = w + marietta.webcad.WebCADGlobal.WALL_WIDTH;
          break;
        default: break;
      }

      this.wall.update();
      this.hashira1.update();
      this.hashira2.update();
      this.resizeObj.update();
      this.yoroi1.update();
      this.yoroi2.update();

      // 線幅を整える
      this.resizeObj.unscaleStrokeWidth(this.resizeObj.scaleY);
    }

    // /**
    //  * 壁への吸着
    //  */
    // snapToWall=() => {
    //   // 初期配置モードではなく、初期ドラッグして少しであれば、無視
    //   if (!this.isFollowingMouse && this.previousPlace !== undefined && this.previousPlace !== null) {
    //     const currentPoint: marietta.core.Point = new marietta.core.Point(this.itemInfo.x, this.itemInfo.y);
    //     if (marietta.core.Point.distance(currentPoint, this.previousPlace) < 30) return;
    //   }

    //   // 壁のへの吸着
    //   const closestWall = this.getClosestWallInfo();
    //   if (closestWall === undefined || closestWall === null) return;
    //   if (!closestWall.wall) return;
    //   //            console.log('angle', closestWall.wall.angle);

    //   const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
    //   const sc: number = 1 / root.scaleX;

    //   // 部屋のバウンド情報取得して中心点を探す
    //   const parentRoomBound = closestWall.wall.parentObj.spt.element.getBoundingClientRect();
    //   const minRoomBound: marietta.core.Point = new marietta.core.Point(parentRoomBound.left, parentRoomBound.top);
    //   const maxRoomBound: marietta.core.Point = new marietta.core.Point(parentRoomBound.left + parentRoomBound.width, parentRoomBound.top + parentRoomBound.height);
    //   const parentRoomCenter: marietta.core.Point = new marietta.core.Point((minRoomBound.x + maxRoomBound.x) / 2, (minRoomBound.y + maxRoomBound.y) / 2);

    //   // 壁の中心点を取得
    //   const wallBound = closestWall.wall.viewObj.getBoundingClientRect();
    //   const minWallBound: marietta.core.Point = new marietta.core.Point(wallBound.left, wallBound.top);
    //   const maxWallBound: marietta.core.Point = new marietta.core.Point(wallBound.left + wallBound.width, wallBound.top + wallBound.height);
    //   const wallCenter: marietta.core.Point = new marietta.core.Point((minWallBound.x + maxWallBound.x) / 2, (minWallBound.y + maxWallBound.y) / 2);

    //   // 2点間の角度
    //   const r = Math.atan2((parentRoomCenter.y - wallCenter.y), (parentRoomCenter.x - wallCenter.x));

    //   let deg = ((r * 180) / Math.PI + 270) % 360;
    //   deg = Math.abs((deg) - ((closestWall.wall.angle + 180) % 360)) < 90
    //     ? (closestWall.wall as marietta.webcad.item.parts.Wall).angle
    //     : (closestWall.wall as marietta.webcad.item.parts.Wall).angle - 180;

    //   // 差分の角度
    //   const degDiff: number = Math.abs(Math.max(this.itemInfo.rotation, deg) - Math.min(this.itemInfo.rotation, deg));
    //   // 配置後でさらに、180度回転するようなものは回転しない
    //   if (!this.isFollowingMouse && degDiff % 180 === 0) {
    //     // 回転の適用はしない
    //   } else {
    //     // 角度が180度間違っているので調整
    //     this.itemInfo.rotation = deg - 180;
    //   }

    //   this.itemInfo.x = closestWall.point.x * sc;
    //   this.itemInfo.y = closestWall.point.y * sc;
    //   this.updateTransforms();

    //   // 呼ぶのは一度だけでいいのでドラックをして移動するタイミングと話したときのタイミングの方に移動
    //   // //アイテムを自分と同期させる
    //   // if( marietta.webcad.WebCADGlobal.itemManager.itemController != undefined ){
    //   //     marietta.webcad.WebCADGlobal.itemManager.itemController.syncMeToTarget();
    //   // }
    // }

    /**
     * 建具のガイド表示を更新する（対象コントローラーが建具用の場合のみ）
     */
    private updateFittingGuideViewIfNeeded(): void {
      if (marietta.webcad.WebCADGlobal.itemManager.itemController === undefined) return;
      if (this.itemInfo.id.substring(0, Fitting.FITTING_ID_PREFIX_LENGTH) !== Fitting.FITTING_ID_PREFIX) return;
      if (!(marietta.webcad.WebCADGlobal.itemManager.itemController instanceof marietta.webcad.control.ItemControllerFitting)) return;
      marietta.webcad.WebCADGlobal.itemManager.itemController.updateGuideView();
    }

    /**
    * 壁への吸着
    * @param onMouseMove マウス位置を吸着先探索の基準にするか（falseの場合はitemInfo.x/yを基準にする）
    * @param updatePosition 吸着結果でitemInfo.x/y/rotationを上書きするか。falseの場合は最寄り壁の関連付け（snapWall）のみ行い、座標・回転は保持する
    */
    snapToWall = (onMouseMove: boolean = true, updatePosition: boolean = true) => {
      if (this.snapWall) {
        this.prevSnapWall = this.snapWall;
      }
      this.snapWall = null;
      this.updateFittingGuideViewIfNeeded();
      // 初期配置モードではなく、初期ドラッグして少しであれば、無視
      // if (!this.isFollowingMouse && this.previousPlace != undefined && this.previousPlace != null) {
      //     var currentPoint: marietta.core.Point = new marietta.core.Point(this.itemInfo.x, this.itemInfo.y);
      //     if (marietta.core.Point.distance(currentPoint, this.previousPlace) < 10) return;
      // }
      // if(!onMouseMove)this.updateWallList();
      // 壁のへの吸着
      const closestWall = onMouseMove ? this.getClosestWallInfo() : this.getClosestWallInfo(new marietta.core.Point(this.itemInfo.x, this.itemInfo.y));

      if (closestWall === undefined || closestWall == null) return;
      if (closestWall.wall === undefined) return;
      //            console.log('angle', closestWall.wall.angle);

      // 最寄り壁との関連付けのみ行い、座標・回転は保持する（JSON読込直後の復元時など）
      this.snapWall = closestWall.wall;
      if (!updatePosition) {
        this.updateFittingGuideViewIfNeeded();
        return;
      }

      const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
      const sc: number = 1 / root.scaleX;

      // 部屋のバウンド情報取得して中心点を探す
      const parentRoomBound = closestWall.wall.parentObj.spt.element.getBoundingClientRect();
      const minRoomBound: marietta.core.Point = new marietta.core.Point(parentRoomBound.left, parentRoomBound.top);
      const maxRoomBound: marietta.core.Point = new marietta.core.Point(parentRoomBound.left + parentRoomBound.width, parentRoomBound.top + parentRoomBound.height);
      const parentRoomCenter: marietta.core.Point = new marietta.core.Point((minRoomBound.x + maxRoomBound.x) / 2, (minRoomBound.y + maxRoomBound.y) / 2);

      // 壁の中心点を取得
      const wallBound = closestWall.wall.viewObj.getBoundingClientRect();
      const minWallBound: marietta.core.Point = new marietta.core.Point(wallBound.left, wallBound.top);
      const maxWallBound: marietta.core.Point = new marietta.core.Point(wallBound.left + wallBound.width, wallBound.top + wallBound.height);
      const wallCenter: marietta.core.Point = new marietta.core.Point((minWallBound.x + maxWallBound.x) / 2, (minWallBound.y + maxWallBound.y) / 2);

      // 2点間の角度
      const r = Math.atan2((parentRoomCenter.y - wallCenter.y), (parentRoomCenter.x - wallCenter.x));

      let deg = (((r * 180) / Math.PI) + 270) % 360;
      deg = (closestWall.wall as marietta.webcad.item.parts.Wall).angle - 180;

      if (!this.isSnapToSameWall() && onMouseMove && onMouseMove) {
        this.isCustomRotate = false;
      }

      //カスタムでかつ180度違いの場合は、近い方を採用する
      if( this.isCustomRotate ){
        //回転角度の調整　180度違うだけなら、180度で調整する
        let degDiff: number = Math.abs(Math.max(this.itemInfo.rotation, deg) - Math.min(this.itemInfo.rotation, deg));
        degDiff = degDiff % 360;  //360を超えないようにする

        console.log(this.itemInfo.rotation, deg, degDiff)

        if( 180 <= degDiff ) {
          if(this.itemInfo.rotation < deg){
            deg -= 180;
          }else {
            deg += 180;
          }
        }
        this.itemInfo.rotation = deg;
      }

      // 配置後でさらに、180度回転するようなものは回転しない
      if (!this.isSnapToSameWall() && !this.isCustomRotate) {
        this.itemInfo.rotation = deg;
      }

      this.itemInfo.x = closestWall.point.x * sc;
      this.itemInfo.y = closestWall.point.y * sc;
      this.updateTransforms();

      this.updateFittingGuideViewIfNeeded();
    }

    /**
     * すでに同じ壁にスナップされていることを確認してください
     * @returns boolean
     */
    isSnapToSameWall() {
      if (this.snapWall && this.prevSnapWall) {
        const wall1 = { p1: this.snapWall.startDot.point, p2: this.snapWall.endDot.point };
        const wall2 = { p1: this.prevSnapWall.startDot.point, p2: this.prevSnapWall.endDot.point };
        return marietta.webcad.util.WebCADUtil.isSimilarLine(wall1, wall2);
      }
      return false;
    }

    /**
     * 一番近い壁を探す
     * @return Wall
     */
    getClosestWallInfo(p: marietta.core.Point = null) {
      const tarLayer: marietta.webcad.layer.FloorLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.itemInfo.floor);
      let newPoint: any = tarLayer.spt.localToGlobal(new Point(tarLayer.spt.mouseX, tarLayer.spt.mouseY));
      if (p != null) {
        newPoint = tarLayer.spt.localToGlobal(new Point(Math.round(p.x), Math.round(p.y)));
      }
      marietta.webcad.WebCADGlobal.webcad2Dmanager.updateWallList(this.itemInfo.floor);
      const wallList = marietta.webcad.WebCADGlobal.webcad2Dmanager.wallList;
      // 近い壁を探す
      const closestWalls = [];
      let crossPoint: marietta.core.Point;
      let distance: number;
      for (let i: number = 0; i < wallList.length; i += 1) {
        const startDot = (wallList[i] as marietta.webcad.item.parts.Wall).startDotGlobalPoint;
        const endDot = (wallList[i] as marietta.webcad.item.parts.Wall).endDotGlobalPoint;
        if (!startDot || !endDot) continue;

        crossPoint = marietta.webcad.util.WebCADUtil.calculateCrossPoint(startDot, endDot, newPoint);
        if (crossPoint) {
          distance = marietta.core.Point.distance(crossPoint, newPoint);
          if (distance <= 20 * marietta.webcad.WebCADGlobal.scaleSize) {
            closestWalls.push({ wall: wallList[i] as marietta.webcad.item.parts.Wall, distance, crossPoint });
          }
        }
      }
      if (closestWalls.length < 1) return null;
      let closestWall: marietta.webcad.item.parts.Wall;
      let minDistance = NaN;
      for (let i = 0; i < closestWalls.length; i += 1) {
        if (Number.isNaN(minDistance) || closestWalls[i].distance < minDistance) {
          minDistance = closestWalls[i].distance;
          closestWall = closestWalls[i].wall;
          crossPoint = closestWalls[i].crossPoint;
        }
      }
      return { wall: closestWall, point: crossPoint };
    }

    /**
   * 一番近い壁を探す
   * @return Wall
   */
    getWallsBeneath():marietta.webcad.item.parts.Wall[] {
      const walls:marietta.webcad.item.parts.Wall[] = [];
      const tarLayer: marietta.webcad.layer.FloorLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.itemInfo.floor);
      const newPoint: any = tarLayer.spt.localToGlobal(new Point(this.itemInfo.x, this.itemInfo.y));
      // const { wallList } = marietta.webcad.WebCADGlobal.webcad2Dmanager;

      //同じ階の壁リストの取得
      const wallList:marietta.webcad.item.parts.Wall[] = marietta.webcad.WebCADGlobal.webcad2Dmanager.getWallListByFloor(this.itemInfo.floor);

      // 近い壁を探す
      let crossPoint: marietta.core.Point;
      let distance: number;
      for (let i: number = 0; i < wallList.length; i += 1) {
        const startDot = (wallList[i] as marietta.webcad.item.parts.Wall).startDotGlobalPoint;
        const endDot = (wallList[i] as marietta.webcad.item.parts.Wall).endDotGlobalPoint;
        if (!startDot || !endDot) {
          console.log('getWallsBeneath検出できず')
          continue;
        }

        crossPoint = marietta.webcad.util.WebCADUtil.calculateCrossPoint(startDot, endDot, newPoint);
        if (crossPoint) {
          distance = marietta.core.Point.distance(crossPoint, newPoint);
          if (distance <= 2) {
            walls.push(wallList[i] as marietta.webcad.item.parts.Wall);
          }
        }
      }
      return walls;
    }

    /**
     * 保存データとして出力する幅を計算
     */
    getMyWidthForSave(): number {
      let retW: number;

      switch (this.itemInfo.id) {
        // 柱より、はみ出ているアイテムは柱の間隔をみる
        case 'fit19_01':
        case 'fit20_01':
        case 'fit21_01':
        case 'fit21_06':
        case 'fit23_01':
          retW = this.hashira2.x - this.hashira1.x;
          break;
        default:
          retW = this.itemInfo.width;
          break;
      }

      return Math.abs(retW);
    }

    /**
    * Translateのアップデート
    */
    updateTransforms() {
      this.spt.x = this.itemInfo.x;
      this.spt.y = this.itemInfo.y;
      this.spt.rotation = this.itemInfo.rotation;
      this.spt.update();
      this.updateChildren();
    }

    /**
     * 子供を移動
     */
    moveChildren =(): void => {
      this.updateChildren();
    }

    /**
     * 削除
     * */
    deleteMe(deferredObj = null) {
      // 子供の削除
      this.removeChildren();

      super.deleteMe(deferredObj);
    }

    /**
     * 削除
     * */
    removeChildren=() => {
      if (this.childrenList != null) {
        for (let i: number = this.childrenList.length - 1; i >= 0; i -= 1) {
          this.childrenList[i].deleteMe();
        }
      }
    }

    /**
     * ドラッグ可能か
     */
    public isCapableOfMove(): boolean {
      return super.isCapableOfMove();
    }

    /**
     * 子供を表示
     */
    showChildren=(): void => {
      if (this.childrenList != null) {
        for (let i: number = 0; i < this.childrenList.length; i += 1) {
          this.childrenList[i].show();
        }
      }
    }

    /**
     * 子供を隠す
     */
    hideChildren=(): void => {
      if (this.childrenList != null) {
        for (let i: number = 0; i < this.childrenList.length; i += 1) {
          this.childrenList[i].hide();
        }
      }
    }

    /**
     * 建具高さ情報の設定
     * @param autoHeight
     * @param height
     * @param z
     */
    public setFittingHeightInfo(autoHeight: boolean, height: number = null, z: number = null): void {
      this.itemInfo.auto_height = autoHeight;
      if (!autoHeight) {
        this.itemInfo.fitting_height = height;
        this.itemInfo.z = z;
      }
      // ヒストリーへの保存
      marietta.webcad.WebCADGlobal.webcad2Dmanager.saveToHistory();
    }

    /**
     * 高さ設定を初期化する
     */
    public initializeHeightSetting() {
      this.itemInfo.auto_height = true;
      this.itemInfo.fitting_height = NaN;
      this.itemInfo.z = NaN;
    }

    /**
     * フィッティングアイテムに含まれる部屋リストを取得する
     * @returns
     */
    protected getParentRooms(): marietta.webcad.item.Room[] {
      const roomList: marietta.webcad.item.Room[] = (marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor, ITEM_MODE_NO.MODE_ROOM_NO)).getAllChildren();
      const fittingPoint = new marietta.core.Point(this.itemInfo.x, this.itemInfo.y);
      // 近い壁を探す
      const parentRooms: marietta.webcad.item.Room[] = [];
      let isAlongWall: boolean;
      for (let i: number = 0; i < roomList.length; i += 1) {
        const dotList = roomList[i].itemInfo.globalDotList;
        for (let j: number = 0; j < dotList.length; j += 1) {
          if (j === dotList.length - 1) {
            isAlongWall = marietta.webcad.util.WebCADUtil.isPointInBetweenLine(dotList[j].point, dotList[0].point, fittingPoint);
          } else {
            isAlongWall = marietta.webcad.util.WebCADUtil.isPointInBetweenLine(dotList[j].point, dotList[j + 1].point, fittingPoint);
          }
          if (isAlongWall) {
            parentRooms.push(roomList[i]);
          }
        }
      }
      return parentRooms;
    }

  /**
   * 種類を部屋に応じて変更
   * @returns void
   */
  public changeTypeToRoom():void {
    const rooms: marietta.webcad.item.Room[] = this.getParentRooms();
    //該当なし
    if (rooms.length < 1) return;
    let newCode: string;

    if (this.isOuter()) {
      const hasGenkan:boolean = Boolean((rooms.find((room) => room.itemInfo.id === 'rom03_01')));
      const hasGarage:boolean = Boolean((rooms.find((room) => room.itemInfo.id === 'rom27_01')));
      if (180 <= this.itemInfo.width) {
        newCode = (hasGarage) ? 'fit32_01' : 'fit07_07';
      } else if (60 <= this.itemInfo.width) {
        newCode = hasGenkan ? 'fit05_03' : (hasGarage ? 'fit32_01' : 'fit07_07');
      } else {
        newCode = (hasGarage || hasGenkan)? 'fit03_09' : 'fit15_09';
      }
    } else {
      const hasStorage:boolean = Boolean((rooms.find((room) => room.itemInfo.id === 'rom14_01')));
      const hasBath:boolean = Boolean((rooms.find((room) => room.itemInfo.id === 'rom09_01')));
      if (180 <= this.itemInfo.width) {
        newCode = hasStorage ? 'fit13_02' : (hasBath ? 'fit07_07' : 'fit08_02');
      } else if (120 <= this.itemInfo.width) {
        newCode = hasStorage ? 'fit12_02' : (hasBath ? 'fit14_09' : 'fit07_06');
      } else if (60 <= this.itemInfo.width) {
        newCode = hasStorage ? 'fit10_05' : (hasBath ? 'fit10_06' : 'fit14_08');
      } else {
        newCode = hasStorage ? 'fit04_03' : (hasBath ? 'fit03_09' : 'fit03_08');
      }
    }
    // ホワイトアイテムにする
    this.itemInfo.end_item_info = null;

    // 再描画
    marietta.webcad.view.dialog.FittingTypeSelection.changeFittingType(this, newCode);

    // 見積一覧更新
    marietta.webcad.WebCADGlobal.quotationItemList.requestRebuild();
  }

  /**
   * フィッティングが外側か内側かを確認してください
   * @returns
   */
  private isOuter(): boolean {
    const roomList: marietta.webcad.item.Room[] = (marietta.webcad.WebCADGlobal.layerGroup.getTypeLayerInFloorLayer(marietta.webcad.WebCADGlobal.webcad2Dmanager.currentFloor, ITEM_MODE_NO.MODE_ROOM_NO)).getAllChildren();
    const allPointList: any[] = marietta.webcad.WebCADGlobal.webcad2Dmanager.getAllRoomPointList(roomList);
    marietta.webcad.WebCADGlobal.scene = new graphicLibs.Scene();
    if (allPointList.length > 0) {
      allPointList.forEach((pList: any) => {
        marietta.webcad.WebCADGlobal.scene.add(new graphicLibs.objects.ClosePath(pList));
      });
    }
    const outerList = marietta.webcad.WebCADGlobal.scene.geometoryBuilder.outer();
    const { points } = marietta.webcad.WebCADGlobal.scene.geometoryBuilder.pointlist;
    const outerPoints = []; // 外側のポイントリスト
    outerList.forEach((outer: number[]) => {
      for (let i = 1; i <= outer.length; i += 1) {
        outerPoints.push({ p1: points[outer[i - 1]], p2: points[outer[i % outer.length]] });
      }
    });
    const fittingPoint = new marietta.core.Point(this.itemInfo.x, this.itemInfo.y);
    let isOuter = false;
    for (let j: number = 0; j < outerPoints.length; j += 1) {
      isOuter = marietta.webcad.util.WebCADUtil.isPointInBetweenLine(outerPoints[j].p1, outerPoints[j].p2, fittingPoint);
      if (isOuter) {
        break;
      }
    }
    return isOuter;
  }
}
export default Fitting;
